export const BASEURL = "https://apis.gargian.com/api/";
export const IMGURL = "https://apis.gargian.com";
export const APIENDPOINTS = {
  CATEGORY: "all",
  REGISTER: "register",
  LOGIN: "login",
  CATEGORIES: "category",
  PRODUCT: "pro",
  ORDER: "order",
  OCCUPTION: "occupation",
  BANNER: "banner",
  ORD: "orders",
  Profile: "profile",
  ZOHOORDER: "orders",
  ZOHOUSER: "users",
  ZOHOCHECK: "create-customer",
  ZOHOACTIVEITEM: "get-active-item",
  CREATE_RAZORPAY_ORDER: "create-razorpay-order",
  REVIEWS: "reviews",
  COUPON: "coupon",
  EXCEL: "/download-items",
  INVOICE: "invoice",
};
